<template>
  <FormFieldWrapper :data="data">
    <VAInput
      :modelValue="modelValue"
      @update:modelValue="handleInput"
      @blur="handleBlur"
      placeholder="0"
      :validateFunc="numericValidation"
      :error-message="errorMessage"
    />
    <div v-if="data?.isLimited && (data?.min != null || data?.max != null)" class="limit-hint">
      <span v-if="data?.min != null && data?.max != null">
        Value must be between {{ data.min }} and {{ data.max }}
      </span>
      <span v-else-if="data?.min != null">
        Value must be at least {{ data.min }}
      </span>
      <span v-else-if="data?.max != null">
        Value must be at most {{ data.max }}
      </span>
    </div>
  </FormFieldWrapper>
</template>

<script>
import FormFieldWrapper from './FormFieldWrapper.vue';

export default {
  name: 'Numeric',
  components: { FormFieldWrapper },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    modelValue: {
      type: [Number, String],
      default: ""
    },
    customValidation: {
      type: Function,
      default: null
    }
  },
  created() {
    console.log('Numeric created', this.modelValue);
  },
  data() {
    return {
      errorMessage: '',
      shouldValidate: false
    };
  },
  emits: ['update:modelValue', 'blur', 'validation-error-changed'],
  computed: {
    numericValidation() {
      return (value)=>{
        var isValid = true;
        if(this.shouldValidate){
          if(value){
            if(isNaN(value)){
              this.errorMessage = 'Please enter a valid number';
              isValid = false;
            }else{
              const num = Number(value);
              if(this.data?.min != null && num < this.data.min){
                this.errorMessage = `Value must be at least ${this.data.min}`;
                isValid = false;
              }
              if(this.data?.max != null && num > this.data.max){
                this.errorMessage = `Value must be at most ${this.data.max}`;
                isValid = false;
              }
            }
          }
          if(this.customValidation){
            const error = this.customValidation(value);
            if(error){
              isValid = false;
              this.errorMessage = error;
            }
          }
        }
        this.$emit('validation-error-changed', !isValid);

        return isValid;
      }
    }
  },
  methods: {
    handleInput(value) {
      // Clear validation flag when user types
      this.shouldValidate = false;
      this.$emit('update:modelValue', value);
    },
    handleBlur() {
      // Enable validation and trigger it
      this.shouldValidate = true;
      this.$emit('blur', this.modelValue);
    }
  }
};
</script>

<style scoped>
.limit-hint {
  margin-top: 4px;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #666;
}
</style>
